import React, { FunctionComponent, ComponentProps } from "react";

const ScriptSolidIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M5 2C3.89543 2 3 2.89543 3 4V12C3 13.1046 3.89543 14 5 14H11C12.1046 14 13 13.1046 13 12V4C13 2.89543 12.1046 2 11 2H5ZM5.25 6L10.75 6V5L5.25 5L5.25 6ZM10.75 8.5H5.25L5.25 7.5H10.75V8.5ZM5.25 11H10.75V10H5.25L5.25 11Z",
    })
  );
};

const ForwardRef = React.forwardRef(ScriptSolidIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
